class TabbedContent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Small timeout ensures nested blocks have been fully processed by Shopify's liquid rendering engine
    setTimeout(() => {
      this.buildTabs();
    }, 0);
  }

  buildTabs() {
    const headersContainer = this.querySelector(".tabbed-section__headers");
    if (!headersContainer) return;
    headersContainer.innerHTML = ""; // prevent duplicates on element swap

    const panels = this.querySelectorAll('[role="tabpanel"]');

    panels.forEach((panel, index) => {
      const title =
        panel.getAttribute("data-tab-title") || "Tab " + (index + 1);
      const btn = document.createElement("button");

      btn.setAttribute("role", "tab");
      btn.className = `tabbed-section__tab ${index === 0 ? "is-active" : ""}`;
      btn.setAttribute("aria-selected", index === 0 ? "true" : "false");
      btn.setAttribute("aria-controls", panel.id);
      btn.setAttribute("data-tab-target", panel.id);
      btn.textContent = title;

      btn.addEventListener("click", this.onTabClick.bind(this));
      headersContainer.appendChild(btn);

      // Hide inactive panels
      if (index !== 0) {
        panel.setAttribute("hidden", "");
      } else {
        panel.removeAttribute("hidden");
      }
    });

    this.tabs = this.querySelectorAll('[role="tab"]');

    // Select appropriate tab if Theme Editor selects a block natively
    this.addEventListener("shopify:block:select", (event) => {
      const matchingTab = this.querySelector(
        `[data-tab-target="panel-${event.detail.blockId}"]`,
      );
      if (matchingTab) {
        matchingTab.click();
      } else {
        // It's possible the block selected is INSIDE a tab panel. Find its closest panel parent.
        const element = event.target;
        const closestPanel = element.closest('[role="tabpanel"]');
        if (closestPanel) {
          const matchingParentTab = this.querySelector(
            `[data-tab-target="${closestPanel.id}"]`,
          );
          if (matchingParentTab) matchingParentTab.click();
        }
      }
    });
  }

  onTabClick(event) {
    if (document.activeElement) document.activeElement.blur(); // reset focus visually

    const selectedTab = event.currentTarget;

    this.tabs.forEach((tab) => {
      tab.setAttribute("aria-selected", "false");
      tab.classList.remove("is-active");
    });
    selectedTab.setAttribute("aria-selected", "true");
    selectedTab.classList.add("is-active");

    const targetId = selectedTab.getAttribute("data-tab-target");
    const panels = this.querySelectorAll('[role="tabpanel"]');

    panels.forEach((panel) => {
      if (panel.id === targetId) {
        panel.removeAttribute("hidden");
      } else {
        panel.setAttribute("hidden", "");
      }
    });
  }
}

if (!customElements.get("tabbed-content")) {
  customElements.define("tabbed-content", TabbedContent);
}
